import { Component, Input, Output, EventEmitter, Inject, Optional, input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { ErrorTraceIdComponent } from '../error-trace-id/error-trace-id.component';

/** Contador de módulo: da a cada instancia su propio id de mensaje (feature 33, R10). */
let siguienteId = 0;

/**
 * Datos del modal cuando se abre vía `MatDialog`. Sustituye al `any` que tenía
 * antes: `message` acepta un string o la lista de líneas (p. ej. el desglose de
 * `INSUFFICIENT_FUNDS`), y `traceId` es la referencia de soporte del contrato de
 * errores — opcional, porque no toda respuesta la trae.
 */
export interface ErrorModalData {
  message: string | string[];
  traceId?: string;
}

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [CommonModule, TranslocoModule, ErrorTraceIdComponent],
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss'
})
export class ErrorModalComponent {
  @Input() set errorMessage(value: string | string[]) {
    if (Array.isArray(value)) {
      this.errorMessages = value;
      this.singleMessage = '';
    } else {
      this.singleMessage = value || '';
      this.errorMessages = [];
    }
  }
  @Output() closeModal = new EventEmitter<void>();
  testIdScope = input<string>('');

  singleMessage = '';
  errorMessages: string[] = [];
  /** Referencia de soporte; `undefined` cuando la respuesta no la trajo (R9). */
  traceId?: string;
  /** Único en el documento: con un id fijo, varios modales abiertos repetían el
   *  mismo y todos los `aria-labelledby` resolvían al PRIMERO. */
  readonly idMensaje = `error-modal-message-${++siguienteId}`;

  constructor(
    @Optional() public dialogRef: MatDialogRef<ErrorModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ErrorModalData | null
  ) {
    if (data) {
      this.errorMessage = data.message;
      this.traceId = data.traceId;
    }
  }

  onClose(): void {
    if (this.dialogRef) {
      this.dialogRef.close(); // Si es modal de Angular Material
    } else {
      this.closeModal.emit(); // Si es el modal vía @Output
    }
  }
}